/*
 * Author: Harper Yan
 * File Created: Wednesday, 24-07-10 04:02 pm
 * Last Modified: Monday, 25-04-07 05:47 pm, by Harper Yan
 */

import { ReactElement } from 'react';
import { ButtonProps } from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { Flex } from '@/containers';
import { Icon } from '@/Icon';
import { MessageProps } from '@/message/@type';
import { StyledButton as Button, StyledContent, StyledDialog, StyledFlex, StyledTitle } from './style';
interface StatusDialogButtonProps extends ButtonProps {
  label: string;
}
export interface StatusDialogProps extends MessageProps {
  header: string;
  content: string | ReactElement;
  btn1?: StatusDialogButtonProps;
  btn2?: StatusDialogButtonProps;
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  width?: string;
}
export default function StatusDialog(props: StatusDialogProps) {
  const {
    header,
    content,
    btn1,
    btn2,
    flexDirection,
    ...dialogProps
  } = props;
  return <StyledDialog {...dialogProps} open={dialogProps.open || false} data-sentry-element="StyledDialog" data-sentry-component="StatusDialog" data-sentry-source-file="index.tsx">
      <StyledFlex gap={'24px'} data-sentry-element="StyledFlex" data-sentry-source-file="index.tsx">
        <StyledFlex gap={'8px'} data-sentry-element="StyledFlex" data-sentry-source-file="index.tsx">
          <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="index.tsx">{header}</StyledTitle>
          <StyledContent data-sentry-element="StyledContent" data-sentry-source-file="index.tsx">{content}</StyledContent>
        </StyledFlex>

        <Flex flexDirection={flexDirection ?? 'row'} gap={'16px'} width={'100%'} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          {btn1?.label && <Button sx={{
          minWidth: 'fit-content'
        }} size="medium" onClick={btn1.onClick} color={btn2 ? 'secondary' : 'primary'}>
              {btn1.label}
            </Button>}
          {btn2 && <Button sx={{
          minWidth: 'fit-content'
        }} onClick={btn2.onClick} variant="contained" size="medium">
              {btn2.label}
            </Button>}
        </Flex>
      </StyledFlex>
    </StyledDialog>;
}